import { render, staticRenderFns } from "./adminproject.vue?vue&type=template&id=19b55c2d&scoped=true"
import script from "./adminproject.vue?vue&type=script&lang=js"
export * from "./adminproject.vue?vue&type=script&lang=js"
import style0 from "./adminproject.vue?vue&type=style&index=0&id=19b55c2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b55c2d",
  null
  
)

export default component.exports